//============================================================================
// Name        : ReprintItem.tsx
// Purpose     : Implement reprint label dialog item
// Created     : 2019-07-04
// Author      : Senitron Team
// Copyright   : Copyright 2019 Senitron Corporation. All rights reserved.
//============================================================================

// tslint:disable-next-line:no-unused-expression
/** @jsx jsx */ jsx;
import { css, jsx } from "@emotion/core";
import axios from "axios";
import React from "react";
import { connect } from "react-redux";
import { IReprintItemProps, TagType } from "./types";

const itemQty = css`
    margin-left: 15px;
    width: 115px;
    font-size: 12px;
`;

const itemEpc = css`
    margin-left: 10px;
`;

declare var apiKey: string;
declare var apiUrl: string;

class ReprintItem extends React.Component<IReprintItemProps> {
    onPrintLabel = async () => {
        // Send labels to the server to start printing
        const printData = {
            api_key:   apiKey,
            printerId: this.props.selectedPrinter.value,
            labels:    [this.props.label]
        };
        await axios.post(apiUrl + "/print-labels", printData);
    }

    render() {
        const qty = this.props.label.tagType == TagType.Pallet ? this.props.label.currentUnits : 1;
        return (
            <div css={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: "10px", marginBottom: "15px" }}>
                <div css={{ display: "flex", alignItems: "center" }}>
                    {!this.props.label.verified && <button onClick={this.onPrintLabel} className="man-btn man-green-btn">Re-Print</button>}

                    {this.props.label.tagType == TagType.Pallet &&
                        <div css={itemQty}>Lot# {this.props.label.lotIdx} {this.props.label.palletNumber} of {this.props.label.ofTotalLabelCount}<br/> Exp. {this.props.label.lotExpDate}</div>}
                    <div css={itemEpc}>{this.props.label.epc}</div>
                </div>
                <div>
                    {this.props.label.verified && <span className="label label-success">VALID</span>}
                    {!this.props.label.verified && <span className="label label-danger">MISSING</span>}
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    selectedPrinter:     state.printers.selectedPrinter
});
const mapDispatchToProps = dispatch => ({ });
export default connect(mapStateToProps, mapDispatchToProps)(ReprintItem);
